import { Promise } from "../promise";
import type { Constructor, TypeRef, TypeRefFor } from "./index";


export interface PromiseTypeRef<T = any> extends Constructor<Promise<T>>
{
    resultType: TypeRefFor<T>;
}


export namespace PromiseTypeRef
{
    export function get<T>(resultType: TypeRefFor<T>): PromiseTypeRef<T>;
    export function get(resultType: TypeRef): PromiseTypeRef
    {
        let promiseType = promiseTypes.get(resultType);
        if (promiseType)
            return promiseType;

        promiseType =
            class extends Promise<any>
            {
                static resultType = resultType;
            };

        const typeName = `Promise<${resultType.name}>`;
        Object.defineProperty(promiseType, "name", { value: typeName, writable: false });

        promiseTypes.set(resultType, promiseType);

        return promiseType;
    }


    const promiseTypes = new Map<TypeRef, PromiseTypeRef>();
}


export type PromiseResultType<P extends Promise<any>> =
    P extends Promise<infer T> ? T : never;


// export const isPromiseTypeRef = PromiseTypeRef.isPromiseTypeRef;


export const PromiseOf = PromiseTypeRef.get;
